import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取模板表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getTemplateList(query) {
    return request({
        url: `${baseURL.businessApi}/templates`,
        method: 'get',
        params: query
    })
}

/**
 * 增加模板表 post
 * @param data 增加的数据
 * @return request
 * */
export function addTemplate(data) {
    return request({
        url: `${baseURL.businessApi}/templates`,
        method: 'post',
        data: data
    })
}

/**
 * 删除模板表  delete
 * @param id 模板表id
 * @return request
 * */
export function deleteTemplate(id) {
    return request({
        url: `${baseURL.businessApi}/templates/${id}`,
        method: 'delete'
    })
}

/***
 * 修改模板表 Post
 * @param id 要修改的模板表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateTemplate(id, data) {
    return request({
        url: `${baseURL.businessApi}/templates/${id}`,
        method: 'post',
        data: data
    })
}